import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComparePasswordValidatorDirective } from './_services/compare-password-validator.directive';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { IsProsightEmailValidatorDirective } from './_services/is-prosight-email-validator.directive';
import { VerifyComponent } from './verify/verify.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { HeaderModule } from '../header/header.module';

@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    IsProsightEmailValidatorDirective,
    ComparePasswordValidatorDirective,
    VerifyComponent,
    ActivateUserComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    HeaderModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ComparePasswordValidatorDirective,
    HeaderModule
  ],
  entryComponents: [
    ForgotPasswordComponent,
    ResetPasswordComponent
  ]
})
export class LoginModule { }
